import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import './Login.css';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ org_name: '', slug: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  let slugTouched = false;

  const handleOrgChange = (e) => {
    const val = e.target.value;
    setForm(f => ({
      ...f,
      org_name: val,
      slug: slugTouched ? f.slug : val.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }));
  };

  const handleSlugChange = (e) => {
    slugTouched = true;
    setForm(f => ({ ...f, slug: e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-') }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await client.post('/auth/register', {
        org_name: form.org_name.trim(),
        slug: form.slug.trim(),
        email: form.email.trim(),
        password: form.password,
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('refreshToken', res.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      localStorage.setItem('org', JSON.stringify(res.data.org));
      window.location.href = '/onboarding';
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-dot"></div>
          <span className="login-brand-name">TRACE</span>
        </div>
        <div className="login-tagline">Create your workspace</div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Shop Name</label>
            <input
              type="text"
              placeholder="CT Commercial Paper"
              value={form.org_name}
              onChange={handleOrgChange}
              required
              autoFocus
            />
          </div>
          <div className="login-field">
            <label>Shop ID <span style={{fontSize:'10px',color:'rgba(255,255,255,0.2)',textTransform:'none',letterSpacing:0}}>used to log in</span></label>
            <input
              type="text"
              placeholder="ct-paper"
              value={form.slug}
              onChange={handleSlugChange}
              required
            />
          </div>
          <div className="login-field">
            <label>Email</label>
            <input
              type="email"
              placeholder="you@yourshop.com"
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              required
            />
          </div>
          <div className="login-field">
            <label>Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              required
              minLength={8}
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account →'}
          </button>
        </form>

        <div className="login-footer">
          <span>Already have an account?</span>
          <Link to="/" className="login-register-link">Log In</Link>
        </div>
        <a href="https://traceoperations.com" className="login-back">← Back to traceoperations.com</a>
      </div>
    </div>
  );
}